const environment = {
	production: {
		// API_URI: "https://sv360.limokon.work/be/public/",
		API_URI: "https://sv360-api.limokon.work/",
		BASE_PATH: "https://sv360.limokon.work/",
	},

	staging: {
		API_URI: "https://agt-staging-api.linneasystems.com/",
		BASE_PATH: "https://agt-staging.linneasystems.com/",
	},

	development: {
		API_URI: "http://localhost:8000/",
		BASE_PATH: "http://localhost:3000/",
	}
}

export const getEnv = function (key) {
	let env = process.env.REACT_APP_ENVIRONMENT
	return environment[env][key]
}
